import { useLayoutEffect } from 'react'

import { useInterceptorServiceWithUserToken } from '@/hooks/use-interceptor-service-with-user-token'
import { usersApi } from '@/lib/axios'

interface UseUsersServiceHookProps {
  userToken: string
}

export function useUsersServiceHook({ userToken }: UseUsersServiceHookProps) {
  const { perform } = useInterceptorServiceWithUserToken(usersApi, userToken)

  useLayoutEffect(() => {
    if (userToken) return perform()
  }, [userToken])
}
